export type InstallHintMode = 'prompt' | 'ios'

export const INSTALL_HINT_DISMISSED_KEY = 'install-hint-dismissed'

/**
 * Which install hint to show, if any. `prompt` means the browser handed us a
 * `beforeinstallprompt` event (Android/Chromium); `ios` means Safari on
 * iPhone/iPad, which has no install API so we show manual steps instead.
 */
export function getInstallHintMode({
	userAgent,
	maxTouchPoints,
	standalone,
	dismissed,
	canPrompt,
}: {
	userAgent: string
	maxTouchPoints: number
	standalone: boolean
	dismissed: boolean
	canPrompt: boolean
}): InstallHintMode | null {
	if (standalone || dismissed) return null
	if (canPrompt) return 'prompt'
	return isIosSafari(userAgent, maxTouchPoints) ? 'ios' : null
}

function isIosSafari(userAgent: string, maxTouchPoints: number) {
	// iPadOS Safari reports a desktop Mac user agent, so tell it apart by touch.
	const isIos =
		/iPhone|iPad|iPod/.test(userAgent) ||
		(/Macintosh/.test(userAgent) && maxTouchPoints > 1)
	return isIos && !/CriOS|FxiOS|EdgiOS|OPiOS/.test(userAgent)
}
